// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3TSv3","calendarButtons":"ClockData_calendarButtons__3aJ7U"};